/** @format **/
import { HeaderCheckBoxSelectListElement } from '../../views/lib/search/listTableHeader/HeaderCheckBoxSelectList';

export const getServiceUseTypeName = (useTypeId: number, useTypes: Array<HeaderCheckBoxSelectListElement>): string => {
    let name = '';
    for (let i = 0; i < useTypes.length; i++) {
        if (useTypes[i].value === useTypeId) {
            return useTypes[i].name;
        }
    }
    return name;
};
